import { Space } from 'component/Space'
import { Switch } from 'component/Switch/Switch'
import { Tooltip } from 'component/Tooltip/Tooltip'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'

export const CombinePane = observer(() => {
  const demo = useDemo()
  const combine = demo.form.combine

  const onChange = useLatestCallback((value: boolean) => {
    demo.form.combine = value || null
  })

  return <Space pad={[12, 8]} opposite>
    <Vertical gap={4}>
      <Space gap={4}>
        <Typo size={11} one medium upper>{i18n('Combo')}</Typo>
        <Tooltip tooltip={i18n('ComboTooltip')}>
        <Icon size={16} name="info" secondary />
        </Tooltip>
      </Space>
      <Typo size={11} one secondary>{i18n('UseTwoItemsInOneLook')}</Typo>
    </Vertical>
    <Space>
      <Switch checked={!!combine} onChange={onChange} />
    </Space>
  </Space>
})
